(function () {
  document.querySelectorAll('.lc-look').forEach(function (section) {
    var strip = section.querySelector('.lc-look__strip');
    var tiles = strip ? Array.prototype.slice.call(strip.querySelectorAll('.lc-look__tile')) : [];
    var dotsWrap = section.querySelector('.lc-look__dots');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.lc-look__dot')) : [];
    if (!strip || tiles.length < 2) return;

    var AUTO_MS = 3500;
    var current = 0;
    var timer = null;
    var scrollEndTimeout = null;
    var isMobile = function () {
      return window.matchMedia('(max-width: 749px)').matches;
    };

    function setActive(index) {
      current = index;
      tiles.forEach(function (t, i) {
        t.classList.toggle('lc-look__tile--active', i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('lc-look__dot--active', i === index);
      });
    }

    function scrollToTile(index, smooth) {
      var tile = tiles[index];
      if (!tile) return;
      strip.scrollTo({
        left: tile.offsetLeft - strip.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAuto() {
      stopAuto();
      if (!isMobile()) return;
      timer = window.setInterval(function () {
        var next = (current + 1) % tiles.length;
        scrollToTile(next);
        setActive(next);
      }, AUTO_MS);
    }

    function closestTileIndex() {
      var stripLeft = strip.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      tiles.forEach(function (t, i) {
        var dist = Math.abs((t.offsetLeft - strip.offsetLeft) - stripLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    strip.addEventListener('scroll', function () {
      window.clearTimeout(scrollEndTimeout);
      scrollEndTimeout = window.setTimeout(function () {
        setActive(closestTileIndex());
      }, 120);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        scrollToTile(i);
        setActive(i);
        startAuto();
      });
    });

    // Pause auto-advance while the user is actively touching/dragging.
    strip.addEventListener('pointerdown', stopAuto);
    strip.addEventListener('pointerup', startAuto);

    window.addEventListener('resize', startAuto);

    setActive(0);
    startAuto();
  });
})();
